import React from "react";
import { Button } from "@wearewqa/wqa-design-system";
import { Modal } from "../components/Modal/Modal";
import { Heading } from "../components/Heading";

type AreYouSureModalProps = {
  isOpen: boolean;
  message: string;
  onAccept: () => void;
  onClose: () => void;
};

export const AreYouSureModal = ({
  isOpen,
  message,
  onAccept,
  onClose,
}: AreYouSureModalProps) => {
  return (
    <Modal {...{ isOpen, onClose }}>
      <div className="are-you-sure-modal">
        <Heading type="h2" label="Are you sure?" />

        <span>{message}</span>

        <div className="are-you-sure-modal__buttons">
          <Button label={"Accept"} onClick={() => onAccept()} />
          <Button label={"Decline"} onClick={() => onClose()} />
        </div>
      </div>
    </Modal>
  );
};
